import { getListContactBySearch } from 'api/chat/list-contact';
import { useEffect, useState } from 'react';
import { IConversation, IUser } from 'types/chat';

const useSearchListUser = (
  keySearch: string
): [
  listUser: IUser[],
  loading: boolean,
  setLoading: (load: boolean) => void,
  conversations: IConversation[],
  error: string
] => {
  const [conversations, setConversations] = useState<IConversation[]>([]);
  const [listUser, setListUser] = useState<IUser[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState();

  useEffect(() => {
    if (keySearch) {
      setLoading(true);
      getListContactBySearch(keySearch).subscribe({
        next: (res) => {
          setListUser(res.data.filterUser);
          setConversations(res.data.filterGroups);
        },
        error: (error) => {
          setError(error);
        },
        complete: () => {
          setLoading(false);
        },
      });
    }
  }, [keySearch]);

  return [listUser, loading, setLoading, conversations, error];
};

export default useSearchListUser;
